import React, { useEffect, useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Card, CardContent, CircularProgress, DialogContent, Divider, Slide, TextField, Typography, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import './otter.scss';
import { storeDetailsSaga } from '../redux/saga/merchantServiceSelectors';
import { CITY_TEXT, COUNTRY_CODE_TEXT, FULL_ADDRESS, LOCATION_TEXT, LOCATION_TEXT_LATITUDE, LOCATION_TEXT_LONGITUDE, POSTAL_CODE, STATE_TEXT, STORES_DETAILS } from '../constants/merchantsConstants';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='left' ref={ref} {...props} />;
});

const CssTextField = styled(TextField)({
    '& label.Mui-focused': {
        color: '#111111',
        fontWeight: '700'
    },
});

function StoresDetailsCard(props) {

    let { onClose, open } = props;
	const storesDetails = useSelector(storeDetailsSaga);
    const [loading, setLoading] = useState(true);
    let [selectedValue, setSelectedValue] = useState(null);
    const [listHeight, setListHeight] = useState(200);
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        setEditMode(false);
        if (storesDetails && storesDetails?.data) {
            setSelectedValue({...storesDetails.data});
            setLoading(false);
        }
    }, [storesDetails]);

    useEffect(() => {
        let offsetValue = selectedValue?.data?.order_status === 'COMPLETE' ? 910 : 820;
        let listH = (window.innerHeight - offsetValue) > 100 ? (window.innerHeight - offsetValue) : 100;
        listH = listH > 400 ? 400 : listH
        listH = listH < 100 ? 100 : listH;
        setListHeight(listH);
    }, [window.innerHeight])

    const handleClose = () => {
        onClose(null);
    };

    useEffect(() => {
        if (open) {
            setLoading(true)
        }
    }, [open]);

    //const editStore = () => {
    //    setEditMode(true);
    //}
    //const updateStore = () => {
    //    setLoading(true)
    //    setTimeout(() => {
    //        setLoading(false)
    //        setEditMode(false);
    //    }, 1000);
        
    //}

    //const updateSelectedValue = (value, key) => {
    //    let tempValue = {...selectedValue};
    //    tempValue['address']= {
    //        ...tempValue['address'],
    //        [key] : value
    //    };
    //    setSelectedValue(tempValue);
    //}

    //const updateLocationSelectedValue = (value, key) => {
    //    let tempValue = {...selectedValue};
    //    tempValue['address']= {
    //        ...tempValue['address'],
    //        location : {
    //            ...tempValue['address']['location'],
    //            [key] : value
    //        }
    //    };
    //    setSelectedValue(tempValue);
    //}

    return (
        <>
            {
                <Dialog className='dialog-store-cont'
                    TransitionComponent={Transition}
                    keepMounted
                    slotProps={{ backdrop: { sx: { background: 'rgba(255, 255, 255, 0.25)' } } }}
                    aria-labelledby='alert-dialog-slide-title'
                    aria-describedby='alert-dialog-slide-description'
                    componentsProps={{ backdrop: { style: { backgroundColor: 'rgb(241 241 241 / 40%)' } } }}
                    sx={{
                        borderRadius: '20px',
                        '& .MuiDialog-paper': {
                            minWidth: '475px',
                            maxWidth: '475px',
                            maxHeight: '100vh',
                            position: 'absolute',
                            right: '0px',
                            margin: '100px 0px 0px 0px',
                            height: '100%',
                            backgroundColor: '#F1F1F1',
                            overflow: 'auto'
                        },
                        margin: '0 auto'
                    }} onClose={handleClose} open={open}>

                    {loading && open ? (<>
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: 'white', padding: '15px', fontWeight: 700 }} data-testid='order-details-id'>{STORES_DETAILS} <CloseIcon sx={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => handleClose()} /></DialogTitle>

                        <div className='dialog-store-cont--loading'><CircularProgress /></div>

                    </>) : <>
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: 'white', padding: '15px', fontWeight: 700 }} data-testid='order-details-id'>{STORES_DETAILS} <CloseIcon sx={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => handleClose()} /></DialogTitle>
                        <Divider />
                        <DialogContent className='dialog-store-cont--panelcontent'>
                            <Card sx={{ paddingBottom: 0, marginBottom: '8px' }}>
                                <CardContent sx={{ textAlign: 'left', padding: '0px !important' }}>
                                    <Typography variant='h6' component='div'
                                        sx={{
                                            padding: '16px', fontFamily: 'Basis Grotesque Pro',
                                            borderBottom: '1px solid rgb(241, 241, 241)',
                                            borderBottom: 'none',
                                            display: 'flex', justifyContent: 'space-between',
                                            fontSize: '16px', fontWeight: 'bold', lineHeight: '22px'
                                        }}>
                                        {`Store - ${selectedValue?.name}`}
                                    </Typography>

                                </CardContent>
                            </Card>
                            <Card sx={{ paddingBottom: 0, marginBottom: '8px' }}>
                                <CardContent sx={{ textAlign: 'left', padding: 0 }}>
                                    <Typography variant='h6' component='div'
                                        sx={{
                                            padding: '16px', fontFamily: 'Basis Grotesque Pro',
                                            borderBottom: '1px solid rgb(241, 241, 241)',
                                            borderBottom: 'none',
                                            display: 'flex', justifyContent: 'start',
                                            fontSize: '16px', fontWeight: 'bold', lineHeight: '22px'
                                        }}></Typography>
                                    <div className='dialog-store-cont--subContPad'>
                                        {/* <input className='dialog-store-cont--subtext' value={selectedValue?.address?.fullAddress}></input> */}
                                        <CssTextField
                                            id='fulladdress'
                                            disabled={!editMode}
                                            label={FULL_ADDRESS}
                                            //onChange={e => updateSelectedValue(e.target.value, 'fullAddress')}
                                            className='dialog-store-cont--subtext'
                                            required
                                            variant='outlined'
                                            color='secondary'
                                            type='text'
                                            sx={{ mb: 3 }}
                                            value={selectedValue?.address?.fullAddress || ''}
                                            aria-label={FULL_ADDRESS}
                                            fullWidth
                                        />
                                    </div>
                                    <Divider />
                                    <div className='dialog-store-cont--subContPad'>
                                        {/* <span className='dialog-store-cont--subtext-label'>{POSTAL_CODE}</span>
                                        <input className='dialog-store-cont--subtext' value={selectedValue?.address?.postalCode}></input> */}

                                        <CssTextField
                                            id='postalcode'
                                            disabled={!editMode}
                                            label={POSTAL_CODE}
                                            //onChange={e => updateSelectedValue(e.target.value, 'postalCode')}
                                            className='dialog-store-cont--subtext'
                                            required
                                            variant='outlined'
                                            color='secondary'
                                            type='text'
                                            sx={{ mb: 3 }}
                                            value={selectedValue?.address?.postalCode || ''}
                                            aria-label={POSTAL_CODE}
                                            fullWidth
                                        />
                                    </div>
                                    <Divider />
                                    <div className='dialog-store-cont--subContPad'>
                                        {/* <span className='dialog-store-cont--subtext-label'>{CITY_TEXT}</span> */}
                                        {/* <input className='dialog-store-cont--subtext' value={selectedValue?.address?.city}></input> */}
                                        <CssTextField
                                            id='citytext'
                                            disabled={!editMode}
                                            label={CITY_TEXT}
                                            //onChange={e => updateSelectedValue(e.target.value, 'city')}
                                            className='dialog-store-cont--subtext'
                                            required
                                            variant='outlined'
                                            color='secondary'
                                            type='text'
                                            sx={{ mb: 3 }}
                                            value={selectedValue?.address?.city || ''}
                                            aria-label={CITY_TEXT}
                                            fullWidth
                                        />
                                    </div>
                                    <Divider />
                                    <div className='dialog-store-cont--subContPad'>
                                        {/* <span className='dialog-store-cont--subtext-label'>{STATE_TEXT}</span>
                                        <input className='dialog-store-cont--subtext' value={selectedValue?.address?.state}></input> */}
                                        <CssTextField
                                            id='statetext'
                                            disabled={!editMode}
                                            label={STATE_TEXT}
                                            //onChange={e => updateSelectedValue(e.target.value, 'state')}
                                            className='dialog-store-cont--subtext'
                                            required
                                            variant='outlined'
                                            color='secondary'
                                            type='text'
                                            sx={{ mb: 3 }}
                                            value={selectedValue?.address?.state || ''}
                                            aria-label={STATE_TEXT}
                                            fullWidth
                                        />
                                    </div>
                                    <Divider />
                                    <div className='dialog-store-cont--subContPad'>
                                        {/* <span className='dialog-store-cont--subtext-label'>{COUNTRY_CODE_TEXT}</span>
                                        <input className='dialog-store-cont--subtext' value={selectedValue?.address?.countryCode}></input> */}
                                        <CssTextField
                                            id='citytext'
                                            disabled={!editMode}
                                            label={COUNTRY_CODE_TEXT}
                                            //onChange={e => updateSelectedValue(e.target.value, 'country')}
                                            className='dialog-store-cont--subtext'
                                            required
                                            variant='outlined'
                                            color='secondary'
                                            type='text'
                                            sx={{ mb: 3 }}
                                            value={selectedValue?.address?.countryCode || ''}
                                            aria-label={COUNTRY_CODE_TEXT}
                                            fullWidth
                                        />
                                    </div>

                                    <Divider />
                                    <div className='dialog-store-cont--subContPad'>
                                        {/* <span className='dialog-store-cont--subtext-label'>{LOCATION_TEXT}</span>
                                        <input className='dialog-store-cont--subtext' value={selectedValue?.address?.location?.latitude} placeholder='Latitude'></input>
                                        <input className='dialog-store-cont--subtext' value={selectedValue?.address?.location?.longitude} placeholder='Longitude'></input> */}
                                        <CssTextField
                                            id='citytextLat'
                                            disabled={!editMode}
                                            label={LOCATION_TEXT_LATITUDE}
                                            //onChange={e => updateLocationSelectedValue(e.target.value, 'latitude')}
                                            className='dialog-store-cont--subtext'
                                            required
                                            variant='outlined'
                                            color='secondary'
                                            type='text'
                                            sx={{ mb: 3 }}
                                            value={selectedValue?.address?.location?.latitude || ''}
                                            aria-label={LOCATION_TEXT_LATITUDE}
                                            fullWidth
                                        />
                                        <CssTextField
                                            id='citytextLong'
                                            disabled={!editMode}
                                            label={LOCATION_TEXT_LONGITUDE}
                                            //onChange={e => updateLocationSelectedValue(e.target.value, 'longitude')}
                                            className='dialog-store-cont--subtext'
                                            required
                                            variant='outlined'
                                            color='secondary'
                                            type='text'
                                            sx={{ mb: 3 }}
                                            value={selectedValue?.address?.location?.longitude || ''}
                                            aria-label={LOCATION_TEXT_LONGITUDE}
                                            fullWidth
                                        />
                                    </div>

                                    <Divider />
                                    {/* {!editMode ?
                                        <div className='details-button-container'>
                                            <button className='details-class' aria-label='Edit'
                                                variant='outlined' onClick={() => editStore()}>Edit</button>

                                            <button className='details-class' aria-label='Edit'
                                                variant='outlined' onClick={() => handleClose()}>Close</button>
                                        </div> :
                                        <div className='details-button-container'>
                                            <button className='details-class' aria-label='Update'
                                                variant='outlined' onClick={() => updateStore()}>Update</button>

                                            <button className='details-class' aria-label='Edit'
                                                variant='outlined' onClick={() => handleClose()}>Close</button>
                                        </div>} */}

                                </CardContent>
                            </Card>
                        </DialogContent>
                    </>}
                </Dialog >
            }
        </>

    );
}

export default StoresDetailsCard;
